module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-1-93c44116.jpg";